import axios, { AxiosError } from 'axios';
import environment from '../environment';
import { StatusCodes } from 'http-status-codes';
import { getSessionToken } from 'util/parseSelectors';
import { CloudFunctionRequestError } from '@asurion-core/frontend-utils/lib/ErrorsModule/ErrorsModule';

const CLOUD_FUNCTIONS_BASE_URL = `${environment.app.serverApiUrl}/cloud-functions/v2`;

const _cloudFunctionUrl = (functionName) => `${CLOUD_FUNCTIONS_BASE_URL}/${functionName}`;

export default async function makeCloudFunctionRequest(functionName, data) {
  try {
    const url = _cloudFunctionUrl(functionName);

    const sessionToken = getSessionToken();
    const sessionTokenHeader = sessionToken ? { 'x-session-token': sessionToken } : null;
    const headers = { ...sessionTokenHeader };

    const response = await axios.post(url, data, { headers });

    if (
      response.data &&
      typeof response.data === 'object' &&
      Object.keys(response.data).length > 0 &&
      !response.data.hasOwnProperty('result')
    ) {
      throw new CloudFunctionRequestError('The server returned an invalid response.');
    }

    if (response.status === StatusCodes.NO_CONTENT) {
      return;
    }

    return response.data.result;
  } catch (error) {
    if (error.code === AxiosError.ERR_NETWORK) {
      throw new CloudFunctionRequestError('Network error');
    }

    return handleError(error);
  }
}

function handleError(error) {
  const errorData = error?.response?.data;

  if (!errorData) {
    throw new CloudFunctionRequestError('The server returned an invalid response.');
  }

  throw new CloudFunctionRequestError(null, errorData);
}
